import axios from 'axios'
import {setStorage, getStorage} from '@/util'
import {Message, MessageBox} from 'element-ui'

//取得驗證碼-註冊
export const REGISTER_SMS = async ({dispatch, commit}, payload) => {
    const res = await axios.get('/api/driver/register/sms', {
        params: payload
    })
    return res
}
//註冊
export const REGISTER = async ({dispatch, commit}, payload) => {
    const res = await axios.post('/api/driver/register', {
        ...payload
    })
    return res.data
}
//取得驗證碼-忘記密碼
export const FORGET_SMS = async ({dispatch, commit}, payload) => {
    const res = await axios.get('/api/driver/forget/sms', {
        params: payload
    })
    return res
}
//忘記密碼
export const RESET_PASSWORD = async ({dispatch, commit}, payload) => {
    const res = await axios.put('/api/driver/forget/reset/password', {
        ...payload
    })
    return res.data
}
//登入
export const LOGIN = async ({dispatch, commit}, payload) => {
    const res = await axios.get('/api/driver/login', {
        params: payload
    })
    return res.data
}
//確認登入狀態
export const LOGIN_STATE = async ({dispatch, commit}, payload) => {
    const res = await axios.post('/api/authenticate/token/refresh', {
        ...payload
    })
    return res.data
}
//首頁-取得優惠列表
export const HOME_PROMOTIONS = async ({dispatch, commit}, payload) => {
    const res = await axios.get('/api/home/promotions/get', {
        params: payload
    }).then((res) => {
        const data = res.data
        commit('SET_TEMP_DATA', {temp: 'homePromotions', data})
    })
    return res
}
//首頁-取得首頁資訊
export const HOME_INFO = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/home/data/get'
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        if (!+res.code) {
            const data = res.data
            commit('SET_TEMP_DATA', {temp: 'homeInfo', data})
        }
        return res
    })
}
//共用-取得地區
export const SEARCH_AREA = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/area/get'
    ]
    dispatch('AXIOS', data, {root: true}).then((res) => {
        const data = (res || {}).data
        commit('SET_TEMP_DATA', {temp: 'searchArea', data})
    })
}
//求職徵才-取得類別
export const JOB_TYPE = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/interview/type/get'
    ]
    dispatch('AXIOS', data, {root: true}).then((res) => {
        const data = (res || {}).data
        commit('SET_TEMP_DATA', {temp: 'jobType', data})
    })
}
//求職徵才-取得列表
export const JOB_LIST = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/interview/list',
        {params: payload}
    ]
    return await dispatch('AXIOS', data, {root: true}).then((res) => {
        const clearData = []
        commit('SET_TEMP_DATA', {temp: 'jobList', clearData})
        commit('SET_STATE', false)
        if (!+res.code) {
            //有分頁的資料
            const data = res.pagination.data
            const pageData = {
                last_page: res.pagination.last_page,
                current_page: res.pagination.current_page,
                total: res.pagination.total,
                limit: res.pagination.to
            }
            commit('SET_TEMP_DATA', {temp: 'jobList', data})
            commit('SET_PAGES', pageData)
            commit('SET_STATE', true)
        } else {
            commit('SET_TEMP_DATA', {temp: 'jobList', clearData})
            commit('SET_STATE', false)
        }
        return res
    })
}
//求職徵才-取得我的刊登
export const JOB_MYLIST = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/interview/my/list',
        {params: payload}
    ]
    return await dispatch('AXIOS', data, {root: true}).then((res) => {
        const clearData = []
        commit('SET_TEMP_DATA', {temp: 'jobList', clearData})
        commit('SET_STATE', false)
        if (!+res.code) {
            const data = res.pagination.data
            const pageData = {
                last_page: res.pagination.last_page,
                current_page: res.pagination.current_page,
                total: res.pagination.total,
                limit: res.pagination.to
            }
            commit('SET_TEMP_DATA', {temp: 'jobList', data})
            commit('SET_PAGES', pageData)
            commit('SET_STATE', true)
        } else {
            commit('SET_TEMP_DATA', {temp: 'jobList', clearData})
            commit('SET_STATE', false)
        }
        return res
    })
}
//求職徵才－新增
export const JOB_ADD = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        '/api/interview/add',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//求職徵才－詳情
export const JOB_DETAIL = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/interview/info/get',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        if (!+res.code) {
            const data = res.data
            commit('SET_TEMP_DATA', {temp: 'jobDetail', data})
        }
        return res
    })
}
//求職徵才－刪除
export const JOB_DELETE = async ({dispatch, commit}, payload) => {
    const data = [
        'delete',
        '/api/interview/info/delete',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//求職徵才－編輯
export const JOB_EDIT = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        '/api/interview/info/edit',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//個人資料設定-登出帳號
export const SIGN_OUT = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/driver/logout',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//個人資料設定
export const MODIFY = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        '/api/driver/account/modify?_method=put',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//更改密碼
export const CHANGE_PASSWORD = async ({dispatch, commit}, payload) => {
    const data = [
        'put',
        '/api/driver/password/change',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//系統通知
export const NOTIFICATION_R = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/driver/notification/get',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        if (!+res.code) {
            const data = res.pagination.data
            commit('SET_TEMP_DATA', {temp: 'notificationList', data})
        }
        return res
    })
}
//取得會員資訊
export const USER_INFO = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/driver/member/info',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        if (!+res.code) {
            const data = res.data
            commit('SET_TEMP_DATA', {temp: 'userInfo', data})
        }
        return res
    })
}

//案件交流-取得類別
export const CASE_TYPE = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/case/type'
    ]
    dispatch('AXIOS', data, {root: true}).then((res) => {
        const data = (res || {}).data
        commit('SET_TEMP_DATA', {temp: 'caseType', data})
    })
}
//案件交流-取得車輛類型
export const CAR_TYPE = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/cars'
    ]
    dispatch('AXIOS', data, {root: true}).then((res) => {
        const data = (res || {}).data
        commit('SET_TEMP_DATA', {temp: 'carType', data})
    })
}
//求職徵才-取得列表
export const CASE_LIST = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/case',
        {params: payload}
    ]
    return await dispatch('AXIOS', data, {root: true}).then((res) => {
        const clearData = []
        commit('SET_TEMP_DATA', {temp: 'caseList', clearData})
        commit('SET_STATE', false)
        if (!+res.code) {
            //有分頁的資料
            const data = res.pagination.data
            const pageData = {
                last_page: res.pagination.last_page,
                current_page: res.pagination.current_page,
                total: res.pagination.total,
                limit: res.pagination.to
            }
            commit('SET_TEMP_DATA', {temp: 'caseList', data})
            commit('SET_PAGES', pageData)
            commit('SET_STATE', true)
        } else {
            commit('SET_TEMP_DATA', {temp: 'caseList', clearData})
            commit('SET_STATE', false)
        }
        return res
    })
}
//求職徵才-取得我的刊登
export const CASE_MYLIST = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/case/my',
        {params: payload}
    ]
    return await dispatch('AXIOS', data, {root: true}).then((res) => {
        const clearData = []
        commit('SET_TEMP_DATA', {temp: 'caseList', clearData})
        commit('SET_STATE', false)
        if (!+res.code) {
            const data = res.pagination.data
            const pageData = {
                last_page: res.pagination.last_page,
                current_page: res.pagination.current_page,
                total: res.pagination.total,
                limit: res.pagination.to
            }
            commit('SET_TEMP_DATA', {temp: 'caseList', data})
            commit('SET_PAGES', pageData)
            commit('SET_STATE', true)
        } else {
            commit('SET_TEMP_DATA', {temp: 'caseList', clearData})
            commit('SET_STATE', false)
        }
        return res
    })
}
//求職徵才－新增
export const CASE_ADD = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        '/api/case',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//求職徵才－詳情
export const CASE_DETAIL = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/case/${payload.id}`
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        if (!+res.code) {
            const data = res.data
            commit('SET_TEMP_DATA', {temp: 'caseDetail', data})
        }
        return res
    })
}
//求職徵才－刪除
export const CASE_DELETE = async ({dispatch, commit}, payload) => {
    const data = [
        'delete',
        `/api/case/${payload.id}`
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//求職徵才－編輯
export const CASE_EDIT = async ({dispatch, commit}, payload) => {
    const data = [
        'put',
        `/api/case/${payload.id}`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}


//物件買賣-取得類別
export const SELL_TYPE = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/sale/type'
    ]
    dispatch('AXIOS', data, {root: true}).then((res) => {
        const data = (res || {}).data
        commit('SET_TEMP_DATA', {temp: 'sellType', data})
    })
}
//物件買賣-取得列表
export const SELL_LIST = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/sale',
        {params: payload},
        'sellList'
    ]
    return await dispatch('AXIOS', data, {root: true}).then((res) => {
        const clearData = []
        commit('SET_TEMP_DATA', {temp: 'sellList', clearData})
        commit('SET_STATE', false)
        if (!+res.code) {
            //有分頁的資料
            const data = res.pagination.data
            const pageData = {
                last_page: res.pagination.last_page,
                current_page: res.pagination.current_page,
                total: res.pagination.total,
                limit: res.pagination.to
            }
            commit('SET_TEMP_DATA', {temp: 'sellList', data})
            commit('SET_PAGES', pageData)
            commit('SET_STATE', true)
        } else {
            commit('SET_TEMP_DATA', {temp: 'sellList', clearData})
            commit('SET_STATE', false)
        }
        return res
    })
}
//物件買賣-取得我的刊登
export const SELL_MYLIST = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/sale/my',
        {params: payload}
    ]
    return await dispatch('AXIOS', data, {root: true}).then((res) => {
        const clearData = []
        commit('SET_TEMP_DATA', {temp: 'sellList', clearData})
        commit('SET_STATE', false)
        if (!+res.code) {
            const data = res.pagination.data
            const pageData = {
                last_page: res.pagination.last_page,
                current_page: res.pagination.current_page,
                total: res.pagination.total,
                limit: res.pagination.to
            }
            commit('SET_TEMP_DATA', {temp: 'sellList', data})
            commit('SET_PAGES', pageData)
            commit('SET_STATE', true)
        } else {
            commit('SET_TEMP_DATA', {temp: 'sellList', clearData})
            commit('SET_STATE', false)
        }
        return res
    })
}
//物件買賣-新增
export const SELL_ADD = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        '/api/sale',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//物件買賣-詳情
export const SELL_DETAIL = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/sale/${payload.id}`
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        if (!+res.code) {
            const data = res.data
            commit('SET_TEMP_DATA', {temp: 'sellDetail', data})
        }
        return res
    })
}
//物件買賣-刪除
export const SELL_DELETE = async ({dispatch, commit}, payload) => {
    const data = [
        'delete',
        `/api/sale/${payload.id}`
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//物件買賣-編輯
export const SELL_EDIT = async ({dispatch, commit}, payload) => {
    const data = [
        'put',
        `/api/sale/${payload.id}`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//進行抽獎
export const LOTTERY_DO = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        `/api/lottery`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//取得可抽獎數量
export const LOTTERY_GIFT_AMOUNT = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/lottery/gift/amount`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得會員可抽獎數量
export const MEMBER_LOTTERY_AMOUNT = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/member/lottery/amount`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得會員可抽獎數量
export const GET_MEMBER_GIFTS = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/member/gift`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//更新文章刊登時間
export const RENEW_ARTICLE = async ({dispatch, commit}, payload) => {
    const data = [
        'put',
        `/api/article/renew`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//鹿路小助手
export const GET_HELP_INFO = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/qa`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
};
//FCM Token
export const SET_FCM_TOKEN = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        `/api/fcm`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
};
//取得即時路況
export const GET_TRAFFIC_LIVE = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/freeway/1968`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得系統通知未讀數量
export const GET_SYS_NOT_READ_COUNT = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/notification/not_read/count`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得商品分類
export const GET_STORE_CATEGORY = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/store/category`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得商品
export const GET_PORDUCTS = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/store/products`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得商品明細
export const GET_PRODUCT_DETAIL = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/store/products/${payload.id}`,
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
//取得購物車資訊
export const GET_SHOPPING_CAR = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/shopping_car',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得購物車資訊
export const GET_SHOPPING_CAR_COUNT = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/shopping_car/count',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//異動購物車資訊
export const MODIFY_SHOPPING_CAR = async ({dispatch, commit}, payload) => {
    const data = [
        'put',
        '/api/store/shopping_car/modify',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//異動購物車商品勾選狀態
export const MODIFY_CHECK_SHOPPING_CAR = async ({dispatch, commit}, payload) => {
    const data = [
        'put',
        '/api/store/shopping_car/modify/check',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得縣市資料
export const GET_COUNRIES = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/county',
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得鄉鎮市區資料
export const GET_TOWNS = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/town',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}


//取得商城使用者常用資料
export const GET_MEMBER_STORE_INFOS = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/get/member_info',
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得商城使用者常用資料
export const DELETE_MEMBER_STORE_INFOS = async ({dispatch, commit}, payload) => {
    const data = [
        'delete',
        '/api/store/delete/member_info',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//商城結帳
export const STORE_CHECKOUT = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        '/api/store/checkout',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得商城優惠活動
export const STORE_PROMOTION = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/promotion',
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得購買人常用資訊
export const GET_BUY_INFO = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/get/buy_info',
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

export const GET_ORDER_LIST = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/orders',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

export const GET_ORDER_DETAIL = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/store/orders/${payload.id}`,
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

export const STORE_SEND_MESSAGE = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        `/api/store/message/send`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

export const GET_CHANNEL = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/store/channel`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

export const GET_HISTORY_MESSAGE = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/store/message/history`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

export const MESSAGE_IS_READ = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        `/api/store/chatroom/message/is_read`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

export const GET_CHATROOM_INFO = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/chatroom/info',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//商城重新結帳
export const STORE_RECHECKOUT = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/recheckout',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//訂單退貨
export const RETURN_ORDER = async ({dispatch, commit}, payload) => {
    const data = [
        'put',
        '/api/store/order/return',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得聊天室所有未讀訊息數量
export const GET_CHATROOM_NOT_READ_TOTAL = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/store/chatroom/message/not_read_total',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

//取得討論區未讀訊息數量
export const GET_FORUM_NOT_READ_COUNT = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/forum/not_read_count',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
// 取得分類麵包屑
export const GET_STORE_CATEGORY_BREADCRUMBS = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/store/category/breadcrumb`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

export const GET_STORE_HOT_CATEGORY = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/store/category/hot`,
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}
/** 取得託運訂單 **/
export const GET_SHIPMENT_ORDER = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/shipment/orders',
        {params: payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

/** 取得託運訂單明細 */
export const GET_LAST_SHIPMENT_CONTACT = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/shipment/orders/last/contact',
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

/** 取得貨物類別 */
export const GET_CONTAINER_TYPES = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        '/api/shipment/container/type',
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

/** 新增託運訂單 */
export const ADD_SHIPMENT_ORDER = async ({dispatch, commit}, payload) => {
    const data = [
        'post',
        '/api/shipment/orders',
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

/** 取得託運訂單 */
export const GET_SHIPMENT_ORDER_DETAIL = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/shipment/orders/${payload.id}`,
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

/** 取得託運訂單 */
export const EDIT_SHIPMENT_ORDER = async ({dispatch, commit}, payload) => {
    const data = [
        'put',
        `/api/shipment/orders/${payload.id}`,
        {...payload}
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

/** 取消託運訂單 */
export const CANCEL_SHIPMENT_ORDER = async ({dispatch, commit}, payload) => {
    const data = [
        'patch',
        `/api/shipment/orders/${payload.id}`,
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}

/** 取得託運訂單線上付款資訊 */
export const GET_CONTAINER_PAY_INFO = async ({dispatch, commit}, payload) => {
    const data = [
        'get',
        `/api/shipment/newebpay/data/${payload.id}`,
    ]
    return dispatch('AXIOS', data, {root: true}).then((res) => {
        return res
    })
}








